import gql from "graphql-tag";

export default gql`
	query getClientMacros($cursor: String, $where: Array, $orderBy: String, $orderByDirection: String, $pageSize: Int) {
		clientMacros(
			cursor: $cursor
			where: $where
			orderBy: $orderBy
			orderByDirection: $orderByDirection
			pageSize: $pageSize
		) {
			cursor {
				total
				nextCursor
				previousCursor
			}
			macros {
				id
				name
				active
				created
				updated
			}
		}
	}
`;
